"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorIcon = exports.ErrorContainer = exports.ErrorText = void 0;
var design_system_theme_1 = require("@unmind/design-system-theme");
var styled_components_1 = __importStar(require("styled-components"));
var polished_1 = require("polished");
var typography_1 = require("../../../components/typography");
var icons_1 = require("../../../icons");
var responsive_1 = require("../../../utils/responsive");
var ErrorSize = (_a = {},
    _a['small'] = design_system_theme_1.FontSizes.fontSize14,
    _a['medium'] = design_system_theme_1.FontSizes.fontSize16,
    _a);
exports.ErrorText = (0, styled_components_1.default)(typography_1.BodyText).attrs(function () { return ({}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", ";\n  color: ", ";\n"], ["\n  font-size: ", ";\n  color: ", ";\n"])), function (_a) {
    var $size = _a.$size;
    return (0, polished_1.rem)(ErrorSize[$size]);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.text.error;
});
exports.ErrorContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: ", ";\n  display: flex;\n  align-items: center;\n  width: 100%;\n  border-radius: ", ";\n  background-color: ", ";\n  margin: ", " 0;\n\n  ", "\n"], ["\n  padding: ", ";\n  display: flex;\n  align-items: center;\n  width: 100%;\n  border-radius: ", ";\n  background-color: ", ";\n  margin: ", " 0;\n\n  ", "\n"])), (0, polished_1.rem)(16), (0, polished_1.rem)(12), function (_a) {
    var theme = _a.theme;
    return theme.colors.background.error;
}, (0, polished_1.rem)(8), (0, responsive_1.small)((0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: ", " 0;\n  "], ["\n    margin: ", " 0;\n  "])), (0, polished_1.rem)(24))));
exports.ErrorIcon = (0, styled_components_1.default)(icons_1.Alert).attrs(function (_a) {
    var theme = _a.theme;
    return ({
        primaryColor: theme.colors.text.error,
        width: 16,
        height: 16,
    });
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  flex-shrink: 0;\n  margin-right: ", ";\n"], ["\n  flex-shrink: 0;\n  margin-right: ", ";\n"])), (0, polished_1.rem)(8));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
